module.exports = __webpack_public_path__ + "img/pricing-hero-mobile.1f7d5df9.png";